<template>
  <div class="level-card">
    <div class="card-header">
      <h5 class="header-title">
        <i class="icon-feather-bar-chart"></i> {{ $t('general.profile_level') }}
      </h5>
    </div>
    <div class="divider"></div>
    <div class="card-content">
      <div class="level-item">
        <button class="btn btn-info icon-badge" type="button">
          <i class="icon-feather-award"></i>
        </button>
        <h5 class="level-text">{{ $t('profile.certificate') }}: {{ certificatesCount }}</h5>
      </div>
      <div class="divider"></div>
      <div class="level-item">
        <button class="btn btn-success icon-badge" type="button">
          <i class="uil-coins"></i>
        </button>
        <h5 class="level-text">{{ $t('profile.gain') }}: {{ userPoint }} {{ $t('general.point') }} / {{ userCoin }} Coin</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileLevel',
  props: {
    certificatesCount: {
      type: Number,
      default: 0
    },
    userPoint: {
      type: Number,
      default: 0
    },
    userCoin: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.level-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  margin-top: 12px;
}

/* Backend'den gelen btn stillerini al */
.level-card :deep(.btn) {
  display: inline-flex;
  cursor: pointer;
}

.card-header {
  padding: 10px 12px;
}

.header-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
  display: flex;
  align-items: center;
}

.header-title i {
  font-size: 16px;
  margin-right: 6px;
  color: #2c3e50;
}

.divider {
  height: 1px;
  background-color: #e2e8f0;
  margin: 0;
}

.card-content {
  padding: 12px;
}

.level-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-badge {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.icon-badge i {
  font-size: 20px;
}

.icon-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.level-text {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  flex: 1;
}

.level-item + .divider {
  margin: 12px 0;
}

@media (max-width: 768px) {
  .card-header {
    padding: 12px;
  }

  .header-title {
    font-size: 16px;
  }

  .card-content {
    padding: 12px;
  }

  .icon-badge {
    width: 48px;
    height: 48px;
  }

  .icon-badge i {
    font-size: 22px;
  }

  .level-text {
    font-size: 14px;
  }
}
</style>
